/**
 * @file `GET /persons/{personId}` のクライアント (学習者の生年月日を得る)。
 *
 * @what: 学習者の Person を読み、生年月日 (サーバが復号した平文の日付) を YYYY-MM-DD で返す。
 * @why: 受験のスケジュールで試験日を生年月日から出すため (中学入試は小6の2月1日、など)。
 * @failure: 生年月日が未登録なら null を返す。403や404も呼び手で「出せない」として扱えるように
 *   throw せず null を返す (試験日は手で入れられる)。
 */

import { apiFetch, ApiError } from "@/shared/api/client";

interface PersonResponse {
  id: string;
  display_name: string;
  birth_date?: string | null;
}

export interface LearnerBirth {
  /** YYYY-MM-DD。未登録なら null になる。 */
  birthDate: string | null;
}

export async function fetchLearnerBirth(
  personId: string,
  signal?: AbortSignal,
): Promise<LearnerBirth> {
  try {
    const res = await apiFetch<PersonResponse>(
      `/persons/${encodeURIComponent(personId)}`,
      signal ? { signal } : {},
    );
    const raw = res.birth_date;
    if (!raw) return { birthDate: null };
    const m = /^(\d{4}-\d{2}-\d{2})/.exec(raw);
    return { birthDate: m ? m[1]! : null };
  } catch (e) {
    if (e instanceof ApiError && (e.status === 403 || e.status === 404)) return { birthDate: null };
    throw e;
  }
}
